import CheckBoxOutlined from '@mui/icons-material/CheckBoxOutlined';
import { s } from '../../format/schema';
import { defineFieldType, noSettings } from '../card';
import { CheckboxInput } from './FillInput';
import { FIELD_WIDTH } from '../../format/fieldWidth';

export const checkbox = defineFieldType({
  type: 'checkbox',
  name: 'Checkbox',
  valueKind: 'boolean',
  settings: noSettings,
  defaults: {},
  defaultWidth: () => FIELD_WIDTH.FULL,
  value: s.boolean(),
  emptyValue: false,
  hasDefaultValue: true,
  validations: ['required'],
  operators: ['isFilled', 'isEmpty'],
  palette: [{ name: 'Checkbox', tooltip: 'One tick box, e.g. consent', group: 'Choice', icon: CheckBoxOutlined }],
  isEmpty: value => !value,
  FillInput: CheckboxInput,
  fillLabel: () => 'beside',
});
